import styled from 'styled-components';
import { mixin } from '@wconcept/wconcept-ui-renewal/styles/index';

interface IProps {
  className: string;
  children?: React.ReactNode;
  ref?: any;
}

export const TabsWrap = styled.div<IProps>`
  .tabs-label {
    ${mixin.flex({ justify: 'space-evenly' })};
    background: #fff;

    .tabs-tab {
      position: relative;
      width: 100%;

      &:first-child {
        margin-left: 0 !important;
      }

      &[aria-selected='true'] {
        color: #000;
      }

      > * {
        pointer-events: none;
      }
    }
  }

  .tabs-cont {
    .tabs-panel {
      display: none;

      &[aria-hidden='false'] {
        display: block;
      }
    }
  }
`;
